import React from "react";
import { Button, Row } from "react-bootstrap";
import styled from "styled-components";

const FlexDiv = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const PageControls = ({
  hasNextPage,
  hasPreviousPage,
  onClickNext,
  onClickPrevious,
}) => {
  return (
    <Row>
      <FlexDiv>
        <div>
          <Button
            bsStyle="link"
            bsSize="large"
            disabled={!hasPreviousPage}
            onClick={onClickPrevious}
          >
            Previous Page
          </Button>
        </div>
        <div>
          <Button
            bsStyle="link"
            bsSize="large"
            disabled={!hasNextPage}
            onClick={onClickNext}
          >
            Next Page
          </Button>
        </div>
      </FlexDiv>
    </Row>
  );
};
